// extracted by mini-css-extract-plugin
export var centered = "_d-6";
export var flexible = "_d-5";
export var footer = "_d-k";
export var footerBorder = "_d-l";
export var header = "_d-c";
export var headerBorder = "_d-d";
export var headerDefault = "_d-g";
export var headerMedium = "_d-h";
export var headerPadding = "_d-e";
export var iconAndTitle = "_d-f";
export var large = "_d-4";
export var largePadding = "_d-a";
export var medium = "_d-3";
export var mediumPadding = "_d-9";
export var modal = "_d-0";
export var modalContainer = "_d-b";
export var noPadding = "_d-7";
export var skinny = "_d-1";
export var small = "_d-2";
export var smallPadding = "_d-8";
export var subtitle = "_d-j";
export var title = "_d-i";